import React, { useState } from "react";
import { X, Phone, Loader2 } from "lucide-react";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const PairingCodeModal = ({ open, onClose, whatsAppId }) => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [pairingCode, setPairingCode] = useState("");
  const [loading, setLoading] = useState(false);

  const handleRequestCode = async () => {
    if (!phoneNumber) return;
    setLoading(true);
    try {
      const { data } = await api.post(`/whatsapp/${whatsAppId}/pairing-code`, { phoneNumber });
      setPairingCode(data.code);
    } catch (err) { toastError(err); }
    setLoading(false);
  };

  const handleClose = () => { setPhoneNumber(""); setPairingCode(""); onClose(); };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={handleClose} />
      <div className="relative bg-white dark:bg-slate-900 rounded-xl shadow-xl border border-slate-200 dark:border-slate-700 w-full max-w-sm mx-4">
        <div className="flex items-center justify-between px-5 py-4 border-b border-slate-200 dark:border-slate-700">
          <h2 className="text-base font-semibold text-slate-900 dark:text-slate-100">Código de Emparejamiento</h2>
          <button onClick={handleClose} className="p-1 rounded-lg text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="px-5 py-6">
          {!pairingCode ? (
            <div className="space-y-4">
              <p className="text-sm text-slate-600 dark:text-slate-300">
                Ingresa el número de teléfono con el código de país (ej. 551199999999)
              </p>
              <div className="relative">
                <Phone className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                <input
                  autoFocus
                  type="tel"
                  placeholder="551199999999"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  onKeyDown={(e) => { if (e.key === "Enter") handleRequestCode(); }}
                  className="w-full pl-9 pr-3 py-2.5 text-sm border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all"
                />
              </div>
              <button
                onClick={handleRequestCode}
                disabled={loading || !phoneNumber}
                className="w-full flex items-center justify-center gap-2 px-4 py-2.5 text-sm font-semibold bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-50 transition-colors"
              >
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
                Obtener Código
              </button>
            </div>
          ) : (
            <div className="text-center space-y-4">
              <p className="text-4xl font-black tracking-[0.5em] text-indigo-600 dark:text-indigo-400">{pairingCode}</p>
              <p className="text-xs text-slate-500 dark:text-slate-400">
                Ingresa este código en tu WhatsApp → Dispositivos vinculados → Vincular dispositivo → Vincular con número de teléfono
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PairingCodeModal;
